import './App.css';
import CovidMap from './components/CovidMap';

function App() {
  return (
    <div>
      <CovidMap />
    </div>
  );
}

export default App;
